module.exports = "/_next/static/images/training-7b3979fdbfb5d06ab62c7611a3b80831.jpg";